import merge from 'lodash/merge';
import { StyleSheet } from 'react-native';
import { scrollableConfig, tokens } from '../../constants';
import { checkIsPlatform } from '../../utils';
export var getScrollableStyles = props => {
  var horizontalScroll = props.horizontalScroll,
    scrollTrackColor = props.scrollTrackColor,
    scrollThumbColor = props.scrollThumbColor,
    scrollIndicatorSize = props.scrollIndicatorSize,
    withRoundedBorder = props.withRoundedBorder,
    showScrollbar = props.showScrollbar;
  return StyleSheet.create({
    container: {
      position: 'relative',
      flex: 1
    },
    content: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, checkIsPlatform('web') && {
      flex: 1
    }), {
      width: '100%',
      flexDirection: 'row'
    }), showScrollbar && Object.assign(Object.assign({}, horizontalScroll && {
      paddingBottom: scrollIndicatorSize
    }), !horizontalScroll && {
      paddingRight: scrollIndicatorSize
    })), withRoundedBorder && {
      borderRadius: tokens.borderRadius.BORDER_RADIUS_16
    }), {
      overflow: 'hidden'
    }),
    indicatorContainer: Object.assign(Object.assign(Object.assign({
      position: 'absolute',
      backgroundColor: scrollTrackColor,
      borderRadius: tokens.borderRadius.BORDER_RADIUS_10
    }, horizontalScroll && {
      left: 0,
      bottom: 0,
      width: '100%'
    }), !horizontalScroll && {
      top: 0,
      right: 0,
      height: '100%'
    }), {
      overflow: 'hidden'
    }),
    indicator: {
      backgroundColor: scrollThumbColor,
      borderRadius: tokens.borderRadius.BORDER_RADIUS_8
    }
  });
};
export var getScrollableProps = (props, context) => {
  var _a;
  var theme = (props === null || props === void 0 ? void 0 : props.theme) || (context === null || context === void 0 ? void 0 : context.theme);
  var configProps = merge(scrollableConfig === null || scrollableConfig === void 0 ? void 0 : scrollableConfig[theme], (_a = context === null || context === void 0 ? void 0 : context.scrollable) === null || _a === void 0 ? void 0 : _a[theme]);
  return Object.assign(Object.assign({
    theme
  }, configProps), props);
};